import { FC } from 'react';
import ChevronIcon from '@dynamika-shared/ui/icons/Chevron';
import { twMerge } from '@dynamika-shared/utils/twMerge';

export type CollapseState = 'open' | 'closed' | 'preview';

export type CollapseHeaderProps = {
  collapseValue: CollapseState
  loading?: boolean;
  title: JSX.Element | string;
  withBorder?: boolean;
};

export const CollapseHeader: FC<CollapseHeaderProps> = ({
  collapseValue,
  title,
  loading,
  withBorder = true,
}) => {
  if (loading) {
    return (
      <div className='flex bg-white w-full p-1.5  rounded-t-sm'>
        <div className='w-6 h-6 bg-ghostWhite rounded-full animate-pulse' />
        <div className='w-1/2 h-6 bg-ghostWhite rounded-full animate-pulse ml-2' />
      </div>
    );
  }
  let dir: 'left' | 'right' | 'up' | 'down' = 'down';

  if (collapseValue === 'open') {
    dir = 'up';
  }

  if (collapseValue === 'preview') {
    dir = 'right';
  }
  return (
    <div
      className={twMerge(
        'flex bg-white w-full p-1.5  rounded-t-sm justify-between',
        'transition-all overflow-hidden duration-300 ease-in-out bg-blueTone',
        withBorder && 'border border-brightGray',
        withBorder && collapseValue !== 'closed' && 'border-b-0 ',
        collapseValue === 'closed' && 'rounded-b-sm'
      )}
    >
      <div className='text-1824 font-medium ml-[.6rem]'>{title}</div>
      <ChevronIcon
        className={'h-2 w-2'}
        classNameButton={
          'h-3 w-3 rounded-full border border-brightGray bg-ghostWhite'
        }
        dir={dir}
      />
    </div>
  );
};
